// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bf6bf398","977":"b2e4ec87"}[chunkId] + ".chunk.js";
};